export default __webpack_public_path__ + "media/images/icon_domain_blocks-53f35b47e26a6d3b4274d8c92f08ae5f.png";